import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { profileStatisticsActions } from '../actions/profile-statistics.actions';
import { selectProfileStatistics, selectProfileStatisticsLoaded, selectProfileStatisticsLoading } from '../selectors/profile-statistics.selector';

@Injectable({
    providedIn: 'root',
})
export class ProfileStatisticsFacade {
    private store = inject(Store);

    readonly statistics = this.store.selectSignal(selectProfileStatistics);
    readonly loading = this.store.selectSignal(selectProfileStatisticsLoading);
    readonly loaded = this.store.selectSignal(selectProfileStatisticsLoaded);

    getProfileStatistics(): void {
        this.store.dispatch(profileStatisticsActions.getProfileStatistics());
    }

    clear(): void {
        this.store.dispatch(profileStatisticsActions.clear());
    }
}
